var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":{"name":"v4.3.159"}};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  tracesSampleRate: 0.2,
  ignoreErrors: [
    'Non-Error promise rejection captured',
    /There was an error while hydrating but/i,
    /app:\/\/\/recaptcha\/releases\/.*\/recaptcha__.*\.js/,
  ],
  sourcemaps: {
    assets: ['.next/**/*.map.js', '.next/**/*.js'],
  },
  // Session Replay Configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
  beforeSend(event) {
    // Filter out events based on custom logic
    if (event.level === 'info' || event.level === 'warning') {
      return null; // Don't send info/warning level events
    }
    return event;
  },
});
